import { render, staticRenderFns } from "./ChartViewColumnSizeStandart.vue?vue&type=template&id=28e5ee3e"
import script from "./ChartViewColumnSizeStandart.vue?vue&type=script&lang=js"
export * from "./ChartViewColumnSizeStandart.vue?vue&type=script&lang=js"
import style0 from "./ChartViewColumnSizeStandart.vue?vue&type=style&index=0&id=28e5ee3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports